export const ON_LOGIN_REDIRECT_QUERY_KEY = 'redirect_to';

export default function createRedirectAfterLoginPath(
  redirectPath: string
): string {
  return `/login?${ON_LOGIN_REDIRECT_QUERY_KEY}=${redirectPath}`;
}
